import { useTranslation } from 'react-i18next';

import type { Dashboard } from '@/api/REST/dashboards';
import { IconedLabel } from '@/components/ui/IconedLabel';
import { uiIcons } from '@/constants/uiIcons';
import { formatEnumLabel } from '@/lib/resource-config';

export const DashboardMetaProperties = ({
  dashboardData,
}: {
  dashboardData: Dashboard;
}) => {
  const { t } = useTranslation('dashboard');

  return (
    <>
      {dashboardData.dashboardType && (
        <IconedLabel
          iconName={uiIcons.metadata.dashboard}
          iconColor="secondary"
          tooltip={t('HeaderProperties.DashboardType')}
        >
          {/* reuse enum translations from overview page */}
          {formatEnumLabel(dashboardData.dashboardType, 'dashboardsOverview')}
        </IconedLabel>
      )}
      {dashboardData.ownerName && (
        <IconedLabel
          iconName={uiIcons.metadata.owner}
          iconColor="secondary"
          tooltip={t('HeaderProperties.Author')}
        >
          {dashboardData.ownerName}
        </IconedLabel>
      )}
      {dashboardData.sharingScope && (
        <IconedLabel
          iconName={uiIcons.metadata.sharedWith}
          iconColor="secondary"
          tooltip={t('HeaderProperties.SharedWith')}
        >
          {/* reuse enum translations from overview page */}
          {formatEnumLabel(dashboardData.sharingScope, 'dashboardsOverview')}
        </IconedLabel>
      )}
    </>
  );
};
